import React, { Fragment, useContext } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import ClaimManagementGrid from './ClaimManagementGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, FormControl, InputLabel, makeStyles, MenuItem, Select, TextField, Tooltip } from '@material-ui/core';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import { tooltipDelay } from '../../utils/GridUtils';
import { commonActionHeader, commonFilter } from '../../constants/StyleConstants';
import { AddBox } from '@material-ui/icons';
import NewClaimModal from './NewClaimModal/NewClaimModal';
import ClaimContextProvider from '../../contexts/ClaimContext';
import useClaimManagementPresenter from './ClaimManagementPresenter';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import UpdateOutlinedIcon from '@material-ui/icons/UpdateOutlined';
import ClaimTypeSelect from '../../components/ClaimTypeSelect';
import AreaSelect from '../../components/AreaSelect';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  ...commonActionHeader(theme),
  statusInputControl: {
    width: '7em',
    '& .MuiSelect-select.MuiSelect-select': {
      display: 'flex',
      alignItems: 'flex-end',
      columnGap: '.5em',
    },
  },
  statusOption: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

const Filters = ({
  CLAIM_STATUS,
  selectedSupplier,
  setSelectedSupplier,
  area,
  setArea,
  claimId,
  setClaimId,
  claimType,
  setClaimType,
  dateFrom,
  setDateFrom,
  claimStatus,
  setClaimStatus,
  cleanFilters,
  validateAndSearch,
}) => {
  const classes = useStyles();
  const { isSupplier, canSeeAllAreas } = useContext(LoginContext);
  return (
    <div className={classes.filters}>
      {!isSupplier && <SupplierFilter narrow value={selectedSupplier} setValue={setSelectedSupplier} />}
      {!isSupplier && canSeeAllAreas && <AreaSelect narrow style={{ marginBottom: 4 }} value={area} setValue={setArea} />}
      <TextField
        margin="dense"
        id="claimId"
        style={{ width: 90 }}
        label="ID Reclamo"
        onChange={e => setClaimId(e.target.value)}
        value={claimId}
      />
      <ClaimTypeSelect value={claimType} setValue={setClaimType} />
      <CustomDatePicker value={dateFrom} setValue={setDateFrom} />
      <FormControl margin="dense">
        <InputLabel id="select-state-label">Estado</InputLabel>
        <Select
          className={classes.statusInputControl}
          labelId="select-state-label"
          id="state-select"
          value={claimStatus || ''}
          onChange={e => setClaimStatus(e.target.value)}>
          <MenuItem className={classes.statusOption} value={CLAIM_STATUS.ALL}>
            {CLAIM_STATUS.ALL}
          </MenuItem>
          <MenuItem className={classes.statusOption} value={CLAIM_STATUS.OPEN}>
            {CLAIM_STATUS.OPEN}
            <UpdateOutlinedIcon color="secondary" />
          </MenuItem>
          <MenuItem className={classes.statusOption} value={CLAIM_STATUS.CLOSED}>
            {CLAIM_STATUS.CLOSED}
            <CheckCircleOutlinedIcon color="primary" />
          </MenuItem>
        </Select>
      </FormControl>
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Tooltip title={'Limpiar filtros'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <Button variant="outlined" color="secondary" onClick={cleanFilters}>
            Limpiar
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

const ClaimManagement = () => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const { open, setOpen, rows, firstLoad, loading, reloadGrid, filterProps } = useClaimManagementPresenter();

  return (
    <Fragment>
      <ClaimContextProvider>
        <NewClaimModal open={open} setOpen={setOpen} reloadGrid={reloadGrid} />
      </ClaimContextProvider>
      {isSupplier && (
        <div className={classes.actionHeader}>
          <Button
            variant="contained"
            color="primary"
            className={classes.actionHeaderButton}
            startIcon={<AddBox />}
            onClick={() => setOpen(true)}>
            Iniciar Reclamo
          </Button>
        </div>
      )}
      <ViewPortGridWrapper>
        <Filters {...filterProps} />
        <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
          <ClaimManagementGrid data={rows} loading={loading} reloadGrid={reloadGrid} />
        </DefaultUnrederedGridMessage>
      </ViewPortGridWrapper>
    </Fragment>
  );
};

export default ClaimManagement;
